(function () {
	'use strict';

	// ─────────────────────────────────────────────────────────────────
	//  Configuração
	// ─────────────────────────────────────────────────────────────────
	var RECAPTCHA_SITE_KEY = '6LfLFOorAAAAAPbAQ7kXQ9ldIgDOgZYZp0BEC2tY';
	var WA_NUMBER          = '5548991069587';
	var API_CREATE_LEAD    = '/api/method/manager.manager.website_api.create_lead_website';
	var API_LOGGER         = '/api/method/manager.manager.website_api.new_lead_logger';
	var LEAD_TIMEOUT_MS    = 25000;

	// ─────────────────────────────────────────────────────────────────
	//  Estado global
	// ─────────────────────────────────────────────────────────────────
	var open_dialog_on_close = true;
	var lead_in_flight       = false;

	// ─────────────────────────────────────────────────────────────────
	//  Utilitários de validação
	// ─────────────────────────────────────────────────────────────────
	function validate_email(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}

	function validarTelefone(telefone) {
		var nums = telefone.replace(/\D/g, '');
		return nums.length >= 10 && nums.length <= 13;
	}

	function ivy_toast(msg, type) {
		var isError = type === 'error';
		var container = document.getElementById('ivy-toast-container');
		if (!container) {
			container = document.createElement('div');
			container.id = 'ivy-toast-container';
			container.style.cssText = 'position:fixed;bottom:88px;right:24px;z-index:9999;display:flex;flex-direction:column;gap:10px;pointer-events:none';
			document.body.appendChild(container);
		}

		var toast = document.createElement('div');
		toast.style.cssText = [
			'display:flex;align-items:flex-start;gap:12px',
			'background:var(--ivy-bg)',
			'border:1px solid ' + (isError ? 'rgba(239,68,68,.3)' : 'rgba(22,163,74,.3)'),
			'border-radius:12px',
			'padding:14px 16px',
			'box-shadow:0 8px 32px rgba(0,0,0,.14)',
			'max-width:320px',
			'pointer-events:auto',
			'opacity:0',
			'transform:translateX(24px)',
			'transition:opacity .3s ease,transform .3s ease'
		].join(';');

		var iconBg  = isError ? '#fee2e2' : '#dcfce7';
		var iconClr = isError ? '#dc2626' : '#16a34a';
		var iconPath = isError
			? 'M6 18L18 6M6 6l12 12'
			: 'M5 13l4 4L19 7';

		toast.innerHTML =
			'<div style="width:32px;height:32px;border-radius:8px;background:' + iconBg + ';display:flex;align-items:center;justify-content:center;flex-shrink:0">' +
				'<svg width="16" height="16" fill="none" stroke="' + iconClr + '" stroke-width="2.2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="' + iconPath + '"/></svg>' +
			'</div>' +
			'<div style="flex:1;min-width:0">' +
				'<p style="font-size:.8125rem;font-weight:600;color:var(--ivy-text);margin:0 0 2px">' + (isError ? 'Atenção' : 'Mensagem enviada!') + '</p>' +
				'<p style="font-size:.75rem;color:var(--ivy-text-muted);margin:0;line-height:1.4">' + msg.replace(/<[^>]+>/g, '') + '</p>' +
			'</div>' +
			'<button onclick="this.parentNode.remove()" style="background:none;border:none;cursor:pointer;padding:0;color:var(--ivy-text-muted);flex-shrink:0;line-height:1" aria-label="Fechar">&#x2715;</button>';

		container.appendChild(toast);
		requestAnimationFrame(function () {
			requestAnimationFrame(function () {
				toast.style.opacity = '1';
				toast.style.transform = 'translateX(0)';
			});
		});

		setTimeout(function () {
			toast.style.opacity = '0';
			toast.style.transform = 'translateX(24px)';
			setTimeout(function () { toast.remove(); }, 350);
		}, 5000);
	}

	function show_alert(msg) {
		ivy_toast(msg, 'error');
	}

	// ─────────────────────────────────────────────────────────────────
	//  Freeze de tela durante o envio do lead
	// ─────────────────────────────────────────────────────────────────
	function ivy_freeze() {
		if (document.getElementById('ivy-freeze')) return;
		var overlay = document.createElement('div');
		overlay.id = 'ivy-freeze';
		overlay.setAttribute('role', 'status');
		overlay.setAttribute('aria-live', 'polite');
		overlay.style.cssText = 'position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.35);cursor:wait';
		overlay.innerHTML =
			'<div style="display:flex;align-items:center;gap:12px;background:var(--ivy-bg);color:var(--ivy-text);border-radius:12px;padding:16px 22px;box-shadow:0 8px 32px rgba(0,0,0,.2);font-size:.875rem;font-weight:600">' +
				'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--ivy-primary)" stroke-width="2.5" style="animation:ivy-freeze-spin .8s linear infinite"><path stroke-linecap="round" d="M12 3a9 9 0 1 0 9 9"/></svg>' +
				'Enviando...' +
			'</div>' +
			'<style>@keyframes ivy-freeze-spin{to{transform:rotate(360deg)}}</style>';

		// <dialog> aberto com showModal() fica no top layer: overlay precisa ir dentro dele
		var open_dialog = document.querySelector('dialog[open]');
		(open_dialog || document.body).appendChild(overlay);
	}

	function ivy_unfreeze() {
		var overlay = document.getElementById('ivy-freeze');
		if (overlay) overlay.remove();
	}

	function setFieldError(input, msg) {
		if (!input) return;
		input.style.borderColor = '#f87171';
		input.style.boxShadow   = '0 0 0 3px rgba(239,68,68,.15)';
		var errId = 'ivy-ferr-' + (input.name || input.id);
		var err = document.getElementById(errId);
		if (err) {
			err.textContent = msg;
			err.style.display = 'block';
		}
		input.addEventListener('input', function () {
			input.style.borderColor = '';
			input.style.boxShadow   = '';
			if (err) err.style.display = 'none';
		}, { once: true });
	}

	// ─────────────────────────────────────────────────────────────────
	//  Traffic tracking
	// ─────────────────────────────────────────────────────────────────
	function get_traffic_query_params() {
		var params = {};
		var urlParams = new URLSearchParams(window.location.search);
		urlParams.forEach(function (value, key) { params[key] = value; });
		return params;
	}

	function manage_traffic_origin() {
		try {
			var paid_params = ['gad_campaignid', 'utm_campaign'];
			var queryParams = get_traffic_query_params();
			var has_paid = paid_params.some(function (p) { return queryParams[p]; });

			var referrer = document.referrer;
			if (referrer && referrer.indexOf('ivyapp') === -1) {
				localStorage.setItem('traffic_referrer', referrer);
				localStorage.setItem('init_href', window.location.href);
			}

			if (!localStorage.getItem('init_href')) {
				localStorage.setItem('init_href', window.location.href);
			}

			var today = new Date().toLocaleDateString('sv-SE');
			if (has_paid) {
				localStorage.setItem('traffic_source', 'paid');
				localStorage.setItem('traffic_date', today);
			} else {
				var saved_source = localStorage.getItem('traffic_source');
				var saved_date   = localStorage.getItem('traffic_date');
				if (saved_source && saved_date === today) return;
				localStorage.setItem('traffic_source', 'organic');
				localStorage.setItem('traffic_date', today);
			}
		} catch (e) {
			console.log(e)
		}
	}

	function get_traffic_info() {
		var info = { traffic_source: '', traffic_referrer: '', init_href: '', current_page: window.location.href };
		try {
			info.traffic_source   = decodeURIComponent(localStorage.getItem('traffic_source')  || '');
			info.traffic_referrer = decodeURIComponent(localStorage.getItem('traffic_referrer') || '');
			info.init_href        = decodeURIComponent(localStorage.getItem('init_href')        || '');
		} catch (e) {}
		return info;
	}

	// ─────────────────────────────────────────────────────────────────
	//  Google Ads conversion (delega para a função definida no head_html)
	// ─────────────────────────────────────────────────────────────────
	function gtag_report_conversion(event_name) {
		try {
			// Usa a gtag_report_conversion global definida no head_html (Google Ads)
			if (typeof window.gtag_report_conversion === 'function') {
				window.gtag_report_conversion(event_name);
			} else if (typeof gtag === 'function') {
				gtag('event', event_name);
			}
		} catch (e) {}
	}

	// ─────────────────────────────────────────────────────────────────
	//  Monitor logger (fire-and-forget)
	// ─────────────────────────────────────────────────────────────────
	function make_monitor_logger(subject, sender, message) {
		try {
			fetch(API_LOGGER, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Frappe-CSRF-Token': frappe.csrf_token,
				},
				body: JSON.stringify({ subject: subject, sender: sender, message: message }),
			}).catch(function () {});
		} catch (e) {}
	}

	// ─────────────────────────────────────────────────────────────────
	//  Criação do Lead (core)
	//  data: { nome, company, email, telefone, message, tag_event }
	// ─────────────────────────────────────────────────────────────────
	function create_lead(data, on_success, on_error) {
		// Bloqueia um segundo envio enquanto o primeiro não terminou (qualquer formulário)
		if (lead_in_flight) {
			if (typeof on_error === 'function') on_error();
			return;
		}
		lead_in_flight = true;
		ivy_freeze();

		// settled garante um único desfecho: resposta do servidor ou timeout, o que vier primeiro
		var settled    = false;
		var controller = typeof AbortController === 'function' ? new AbortController() : null;
		var timeout_id = setTimeout(function () {
			if (controller) controller.abort();
			show_alert('O envio demorou mais que o esperado. Verifique sua internet e tente novamente.', 'error');
			done(on_error);
		}, LEAD_TIMEOUT_MS);

		var done = function (callback) {
			if (settled) return;
			settled = true;
			clearTimeout(timeout_id);
			lead_in_flight = false;
			ivy_unfreeze();
			if (typeof callback === 'function') callback();
		};

		var nome               = (data.nome              || '').trim();
		var company            = (data.company           || '').trim();
		var email              = (data.email             || '').trim();
		var telefone           = (data.telefone          || '').trim();
		var message            = (data.message           || '').trim();
		var tag_event          = data.tag_event          || 'conversion';
		var contact_token_9f3a = data.contact_token_9f3a || '';

		var traffic = get_traffic_info();

		make_monitor_logger(
			nome, email,
			'Tag: ' + tag_event + ' | Empresa: ' + company + ' | Tel: ' + telefone + ' | Msg: ' + message
		);

		function submit_lead(recaptcha_token) {
			// reCAPTCHA respondeu depois do timeout: não envia mais
			if (settled) return;
			fetch(API_CREATE_LEAD, {
				method: 'POST',
				signal: controller ? controller.signal : undefined,
				headers: {
					'Content-Type': 'application/json',
					'X-Frappe-CSRF-Token': frappe.csrf_token,
				},
				body: JSON.stringify({
					nome: nome,
					email: email,
					telefone: telefone,
					company: company,
					business_detail: message,
					tag_event: tag_event,
					traffic_source:   traffic.traffic_source,
					traffic_referrer: traffic.traffic_referrer,
					init_href:        traffic.init_href,
					current_page:     traffic.current_page,
					recaptcha_token:       recaptcha_token || '',
					contact_token_9f3a:    contact_token_9f3a,
				}),
			})
			.then(function (r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
			.then(function (res) {
				if (res.ok && res.data.message && res.data.message.success) {
					gtag_report_conversion(tag_event);
					open_dialog_on_close = false;
					done(on_success);
				} else {
					var server_msg = '';
					try {
						var msgs = JSON.parse(res.data._server_messages || '[]');
						if (msgs.length) server_msg = JSON.parse(msgs[0]).message;
					} catch (e) {}
					show_alert(server_msg || 'Ocorreu um erro. Tente novamente ou fale pelo WhatsApp.', 'error');
					done(on_error);
				}
			})
			.catch(function () {
				// Abort do timeout já mostrou o próprio aviso
				if (settled) return;
				show_alert('Erro de conexão. Verifique sua internet e tente novamente.', 'error');
				done(on_error);
			});
		}

		load_recaptcha(
			function () {
				grecaptcha.ready(function () {
					grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
						.then(function (token) { submit_lead(token); })
						.catch(function () { submit_lead(''); });
				});
			},
			function () { submit_lead(''); }
		);
	}

	function load_recaptcha(on_loaded, on_error) {
		if (typeof grecaptcha !== 'undefined') {
			on_loaded();
			return;
		}
		var script = document.createElement('script');
		script.src = 'https://www.google.com/recaptcha/api.js?render=' + RECAPTCHA_SITE_KEY;
		script.onload = on_loaded;
		script.onerror = on_error;
		document.head.appendChild(script);
	}

	// ─────────────────────────────────────────────────────────────────
	//  Modal WhatsApp
	// ─────────────────────────────────────────────────────────────────
	function init_wa_modal() {
		var modal = document.getElementById('ivy-wa-modal');
		var form  = document.getElementById('ivy-wa-form');
		if (!modal || !form) return;

		window.ivyWaModal = {
			open: function () {
				modal.style.setProperty('display', 'flex', 'important');
				document.body.style.overflow = 'hidden';
				var el = document.getElementById('wa-nome');
				if (el) el.focus();
			},
			close: function () {
				modal.style.setProperty('display', 'none', 'important');
				document.body.style.overflow = '';
			},
		};

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && window.ivyWaModal) ivyWaModal.close();
		});

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			var nomeEl     = document.getElementById('wa-nome');
			var empresaEl  = document.getElementById('wa-empresa');
			var emailEl    = document.getElementById('wa-email');
			var telefoneEl = document.getElementById('wa-telefone');
			var nome     = (nomeEl     ? (nomeEl.value     || '') : '').trim();
			var empresa  = (empresaEl  ? (empresaEl.value  || '') : '').trim();
			var email    = (emailEl    ? (emailEl.value    || '') : '').trim();
			var telefone = (telefoneEl ? (telefoneEl.value || '') : '').trim();

			var erros = [];
			if (!nome)                         { setFieldError(nomeEl,     'Informe o nome completo.');                  erros.push(nomeEl); }
			if (!empresa)                      { setFieldError(empresaEl,  'Informe o nome da empresa.');                erros.push(empresaEl); }
			if (!email)                        { setFieldError(emailEl,    'Informe o e-mail.');                         erros.push(emailEl); }
			else if (!validate_email(email))   { setFieldError(emailEl,    'E-mail inválido, ex: nome@empresa.com.br.'); erros.push(emailEl); }
			if (!telefone)                     { setFieldError(telefoneEl, 'Informe o telefone.');                       erros.push(telefoneEl); }
			else if (!validarTelefone(telefone)){ setFieldError(telefoneEl,'Telefone inválido. Ex: (48) 9 9999-9999.');  erros.push(telefoneEl); }
			if (erros.length > 0) { erros[0].focus(); return; }

			var submitBtn = form.querySelector('[type="submit"]');
			if (submitBtn) submitBtn.disabled = true;
			var reEnable = function () { if (submitBtn) submitBtn.disabled = false; };

			create_lead(
				{ nome: nome, company: empresa, email: email, telefone: telefone, message: '', tag_event: 'conversionwpp' },
				function () {
					var texto = 'Ola!\nMeu nome e ' + nome + ', gostaria de conhecer o Ivy ERP.';
					window.open('https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(texto), '_blank', 'noopener,noreferrer');
					reEnable();
					ivyWaModal.close();
				},
				reEnable
			);
		});
	}

	// ─────────────────────────────────────────────────────────────────
	//  Botão flutuante WhatsApp
	// ─────────────────────────────────────────────────────────────────
	function init_wa_float_button() {
		var btn = document.getElementById('ivy-wa-float');
		if (!btn) return;
		btn.addEventListener('click', function () {
			if (window.ivyWaModal) {
				ivyWaModal.open();
			} else {
				window.open('https://wa.me/' + WA_NUMBER, '_blank', 'noopener,noreferrer');
			}
		});
	}

	// ─────────────────────────────────────────────────────────────────
	//  Dialog de saída (exit intent)
	// ─────────────────────────────────────────────────────────────────
	function init_exit_dialog() {
		var path = (document.body.getAttribute('data-path') || '').replace(/^\//, '');
		if (path === 'login' || path === 'message' || path === 'unsubscribe') return;

		var pathname = window.location.pathname.replace(/^\//, '');
		if (pathname === 'base-conhecimento' || pathname.indexOf('kb/') === 0) return;

		var dialog   = document.getElementById('dialog-on-close');
		var closeBtn = document.getElementById('dialog-on-close-action-close');
		var form     = document.getElementById('dialog-on-close-form');
		if (!dialog) return;

		if (closeBtn) {
			closeBtn.addEventListener('click', function () { dialog.close(); });
		}

		if (form) {
			form.addEventListener('submit', function (e) {
				e.preventDefault();
				var nomeEl     = document.getElementById('doc-nome');
				var empresaEl  = document.getElementById('doc-empresa');
				var emailEl    = document.getElementById('doc-email');
				var telefoneEl = document.getElementById('doc-telefone');
				var nome     = (nomeEl     ? (nomeEl.value     || '') : '').trim();
				var empresa  = (empresaEl  ? (empresaEl.value  || '') : '').trim();
				var email    = (emailEl    ? (emailEl.value    || '') : '').trim();
				var telefone = (telefoneEl ? (telefoneEl.value || '') : '').trim();

				var erros = [];
				if (!nome)                         { setFieldError(nomeEl,     'Informe o nome completo.');                  erros.push(nomeEl); }
				if (!empresa)                      { setFieldError(empresaEl,  'Informe o nome da empresa.');                erros.push(empresaEl); }
				if (!email)                        { setFieldError(emailEl,    'Informe o e-mail.');                         erros.push(emailEl); }
				else if (!validate_email(email))   { setFieldError(emailEl,    'E-mail inválido, ex: nome@empresa.com.br.'); erros.push(emailEl); }
				if (!telefone)                     { setFieldError(telefoneEl, 'Informe o telefone.');                       erros.push(telefoneEl); }
				else if (!validarTelefone(telefone)){ setFieldError(telefoneEl,'Telefone inválido. Ex: (48) 9 9999-9999.');  erros.push(telefoneEl); }
				if (erros.length > 0) { erros[0].focus(); return; }

				var submitBtn = form.querySelector('[type="submit"]');
				if (submitBtn) {
					submitBtn.disabled = true;
					submitBtn.style.opacity  = '0.6';
					submitBtn.style.cursor   = 'not-allowed';
					submitBtn.style.filter   = 'none';
				}
				var reEnable = function () {
					if (submitBtn) {
						submitBtn.disabled = false;
						submitBtn.style.opacity = '';
						submitBtn.style.cursor  = '';
					}
				};

				create_lead(
					{ nome: nome, company: empresa, email: email, telefone: telefone, message: '', tag_event: 'conversionclose' },
					function () {
						dialog.close();
						reEnable();
						ivy_toast('Entraremos em contato em breve.', 'success');
					},
					reEnable
				);
			});
		}

		setTimeout(function () {
			document.addEventListener('mouseout', function handler(e) {
				var wa_modal = document.getElementById('ivy-wa-modal');
				var wa_open  = wa_modal && getComputedStyle(wa_modal).display !== 'none';
				if (!e.relatedTarget && e.clientY <= 0 && open_dialog_on_close && !dialog.open && !wa_open) {
					open_dialog_on_close = false;
					dialog.showModal();
					document.removeEventListener('mouseout', handler);
				}
			});
		}, 5000);
	}

	// ─────────────────────────────────────────────────────────────────
	//  Formulário principal de contato
	// ─────────────────────────────────────────────────────────────────
	function init_contact_form() {
		var form = document.getElementById('ivy-contact-form');
		if (!form) return;

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			var fq  = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? (el.value || '').trim() : ''; };
			var nome     = fq('full_name');
			var company  = fq('company');
			var email    = fq('email');
			var telefone = fq('phone');
			var message  = fq('message');

			// Valida todos os campos de uma vez
			var nomeEl     = form.querySelector('[name="full_name"]');
			var companyEl  = form.querySelector('[name="company"]');
			var emailEl    = form.querySelector('[name="email"]');
			var telefoneEl = form.querySelector('[name="phone"]');
			var erros = [];
			if (!nome)                      { setFieldError(nomeEl,     'Informe o nome completo.');                  erros.push(nomeEl); }
			if (!company)                   { setFieldError(companyEl,  'Informe o nome da empresa.');                erros.push(companyEl); }
			if (!email)                     { setFieldError(emailEl,    'Informe o e-mail.');                         erros.push(emailEl); }
			else if (!validate_email(email)){ setFieldError(emailEl,    'E-mail inválido, ex: nome@empresa.com.br.'); erros.push(emailEl); }
			if (!telefone)                     { setFieldError(telefoneEl, 'Informe o telefone.');                    erros.push(telefoneEl); }
			else if (!validarTelefone(telefone)){ setFieldError(telefoneEl,'Telefone inválido. Ex: (48) 9 9999-9999.');erros.push(telefoneEl); }
			if (erros.length > 0) { erros[0].focus(); return; }

			var submitBtn = form.querySelector('[type="submit"]');
			if (submitBtn) submitBtn.disabled = true;

			var reEnable = function () { if (submitBtn) submitBtn.disabled = false; };

			create_lead(
				{ nome: nome, company: company, email: email, telefone: telefone, message: message, tag_event: 'conversion', contact_token_9f3a: fq('contact_token_9f3a') },
				function () {
					form.reset();
					reEnable();
					ivy_toast('Entraremos em contato o mais breve possível.', 'success');
				},
				reEnable
			);
		});
	}

	// ─────────────────────────────────────────────────────────────────
	//  Init
	// ─────────────────────────────────────────────────────────────────
	frappe.ready(function () {
		manage_traffic_origin();
		init_wa_modal();
		init_wa_float_button();
		init_exit_dialog();
		init_contact_form();
	});

	window.ivyLead = { create: create_lead };

})();
